<div class="row">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100 mb-4">
            <div class="row pt-3 pl-4">
                <h2>Selecione um arquivo</h2>
            </div>

            <div class="row pt-3 pl-4">
                <input type="file" accept=".csv" (change)="handleUpload($event)">
            </div>
            <div class="row">
                <div class="col-lg-12" style="text-align: right;">
                    <button mat-flat-button (click)="save()" [disabled]="!data" color="primary" class="btnSize pr-2" >
                        Salvar   
                    </button>
                </div>
            </div>
        </mat-card>

        <div class="alert alert-primary pt-2" *ngIf="showAlert" role="alert">
            Upload Successful!
        </div>
        <div class="alert alert-danger pt-2" *ngIf="showAlertError" role="alert">
            Error on upload file on s3!
        </div>
    </div>
</div>